import { render } from "./DrDikshaSareen.vue?vue&type=template&id=1cdcb85b"
import script from "./DrDikshaSareen.vue?vue&type=script&lang=js"
export * from "./DrDikshaSareen.vue?vue&type=script&lang=js"

import "./DrDikshaSareen.vue?vue&type=style&index=0&id=1cdcb85b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__